// CopyPnrButton.js - liten kopiera-ikon bredvid personnumret (Spår P2).
//
// Kopierar ÅÅMMDDNNNN (10 siffror, samma som formatPnrPasis). Reservnummer/
// utländskt id kopieras som det står. Nekas urklippet markeras texten i
// `textRef` (om given) så att personalen kan trycka Ctrl+C själv.
import React from 'react';
import { toast } from 'react-toastify';
import { formatPnrPasis, isPnrIdType } from '../../utils/personnummer';
import './CopyPnrButton.css';

const selectText = (el) => {
  if (!el) return false;
  try {
    const range = document.createRange();
    range.selectNodeContents(el);
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    return true;
  } catch {
    return false;
  }
};

const CopyPnrButton = ({ personnummer, idType, textRef, className = '' }) => {
  if (!personnummer) return null;
  const value = formatPnrPasis(personnummer, idType);
  const what = isPnrIdType(idType) ? 'Personnummer' : 'Id-nummer';

  const handleCopy = async (e) => {
    // Knappen sitter ibland i klickbara rader/formulär — låt inte klicket bubbla
    e.preventDefault();
    e.stopPropagation();
    try {
      if (!navigator.clipboard?.writeText) throw new Error('clipboard saknas');
      await navigator.clipboard.writeText(value);
      toast.success(`${what} kopierat`);
    } catch {
      if (selectText(textRef?.current)) {
        toast.info(`${what} markerat — tryck Ctrl+C för att kopiera`);
      } else {
        toast.error(`Kunde inte kopiera ${what.toLowerCase()}`);
      }
    }
  };

  return (
    <button
      type="button"
      className={`copy-pnr-btn ${className}`}
      onClick={handleCopy}
      title={`Kopiera ${what.toLowerCase()} (${value})`}
      aria-label={`Kopiera ${what.toLowerCase()}`}
    >
      <i className="far fa-copy"></i>
    </button>
  );
};

export default CopyPnrButton;
